import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    route: null,
    trip: null,
    stepIndex: 0,
    vehicle: true,
    model: null,
  },
  mutations: {
    setItem(state, { key, value }) {
      state[key] = value;
    }
  },
  actions: {
    async loadTrip({ commit }, map) {
      const trip = await axios({
        method: 'GET',
        url: 'https://raw.githubusercontent.com/unitehenry/lula-hack/master/scrapers/trip.json?token=AHALMMZMHPYSDB7W65E2BSDBDUGDC'
      })

      const startLocation = trip.data.directions.routes[0].legs[0].steps[0].start_location;

      map.actions.easeTo({ center: [ startLocation['lng'], startLocation['lat'] ], duration: 2000, zoom: 7 });

      commit('setItem', { key: 'trip', value: trip.data });
    },
    async loadModel({ state, commit }) {
      const model = await axios({
        method: 'GET',
        url: 'https://raw.githubusercontent.com/unitehenry/lula-hack/master/scrapers/model.json?token=AHALMM22G6WPAQXWGJTM2RLBDUGEY'
      });

      commit('setItem', { key: 'model', value: model.data });
    },
    getModelForStep({ state }, step) {
      if(state.model) {
        const coord = step['start_location'];
        return state.model.find(md => {
          return (md['start_location.lat'] === coord['lat'] && md['start_location.lng'] === coord['lng']);
        });
      }
    },
    getModelForRoute({ dispatch }, route) {
      return new Promise(resolve => {
        let score = 0;
        route.legs[0].steps.forEach(async (step, i) => {
          const risk = await dispatch('getModelForStep', step);
          if(risk) {
            score += risk['crashes_predicted_per_hour'];
          }
          if(i === route.legs[0].steps.length - 1) {
            resolve(score);
          }
        });
      });
    }
  }
})
